export const DO_LOGIN = 'auth/login';
export const DO_LOGOUT = 'auth/DO_LOGOUT';
export const GET_USER = 'auth/getUser';
export const DO_SOCIAL_LOGIN = 'auth/DO_SOCIAL_LOGIN';
export const DO_HR_LOGIN = 'auth/login/hr';
